module.exports = __webpack_public_path__ + "img/FZLC_11.ab394649.jpg";